import React from 'react'

const StripeConnectPage = () => {
  return <div>export default StripeConnectPage</div>
}

export default StripeConnectPage
